import AppConfig from "../config/app";

const EventUtils = {
  /**
   * Determines the type of selection
   * @param event
   * @returns {{multi: (null|boolean), range: (null|boolean)}}
   */
  selectionType(event) {
    const { altKey: alt, ctrlKey, metaKey, shiftKey: range } = event;
    const select = {
      multi: AppConfig.isOSX ? metaKey : ctrlKey,
      range,
      alt,
    };

    return select;
  },
  /**
   * Fires a (left) click event on the document. Use within events with stoppedPropagation so libraries
   * listening for document clicks will see the event without triggering other events on the way up.
   * Guarantees React Overlay close events.
   */
  emitPassthroughClick() {
    const passthroughClick = new Event("click");
    passthroughClick.button = 0;
    document.dispatchEvent(passthroughClick);
  },
};

export default Object.freeze(EventUtils);
